/**
 * Created by tigran on 26.05.25
 **/

import React, { FC, useMemo } from 'react';
import { AlertProps } from '@src/context/AlertContext';
import Draggable from 'react-draggable';
import { CloseIcon } from '@src/svg';
import { useLyftSocket } from '@src/hooks';
import { logger } from '@utils/logger';

type LyftButtonType = {
  title: string;
  handleClick: () => void;
  color: string;
};

const LyftButton: FC<LyftButtonType> = ({ title, handleClick, color }) => {
  return (
    <button
      data-test-id="c-lyft-alert"
      className="lyft_button"
      style={{ backgroundColor: color }}
      onClick={handleClick}
    >
      {title}
    </button>
  );
};

export const LyftAlert: FC<AlertProps> = ({
  color,
  setShowAlert,
  title,
  message,
  buttons,
  extraMessages,
  isLoader,
  segmentId,
  RenderItem = null,
  messageStyle,
  extraMessageStyle,
}) => {
  const { removeStatusById } = useLyftSocket();

  const exactColorModal = useMemo(() => {
    if (!color) return {};
    return { backgroundColor: color };
  }, [color]);

  const handleClose = () => {
    if (typeof segmentId === 'number') {
      try {
        removeStatusById?.(segmentId);
      } catch (e) {
        logger.log({ e });
      }
    }
    setShowAlert && setShowAlert(false);
  };

  return (
    <div data-test-id="c-lyft-alert" className="modal">
      <Draggable handle=".modal__header" cancel=".modal__body" bounds="parent">
        <div className="modal__container" style={{ maxWidth: '368px' }}>
          <div
            className="modal__header"
            style={{ cursor: 'move', ...exactColorModal }}
          >
            <h2>{title}</h2>
            <button
              className="close-btn"
              onPointerDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onPointerUp={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClose();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClose();
              }}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body" style={{ ...exactColorModal }}>
            {!RenderItem ? (
              <>
                <div className="lyft_message__wrapper" style={messageStyle}>
                  {message}
                </div>
                {isLoader && (
                  <div className="finding-loader-wrapper">
                    <div className="finding-loader" />
                    <span>Contacting</span>
                    <span>rideshare...</span>
                  </div>
                )}
                {extraMessages &&
                  extraMessages.length > 0 &&
                  extraMessages.map((extraMessage, index) => (
                    <div
                      key={index}
                      className="lyft_message__wrapper"
                      style={extraMessageStyle}
                    >
                      {extraMessage}
                    </div>
                  ))}
                {buttons && buttons.length > 0 && (
                  <div
                    className="lyft_button__wrapper"
                    style={{
                      justifyContent:
                        buttons && buttons.length > 0 && buttons.length !== 1
                          ? 'space-between'
                          : 'flex-end',
                    }}
                  >
                    {buttons.map((button, i) => (
                      <LyftButton
                        key={i}
                        color={button.color}
                        handleClick={() => {
                          button.onClick();
                          handleClose();
                        }}
                        title={button.title}
                      />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <RenderItem />
            )}
          </div>
        </div>
      </Draggable>
    </div>
  );
};
